import { useContext } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import OMNIX_MODULE from "constants/OMNIX_MODULE"
import {
  get_module_entity_action_middleware,
  post_module_entity_action_middleware,
  put_module_entity_action_middleware,
  delete_module_entity_action_middleware,
} from "services/middleware_services"
import Swal from "sweetalert2"

interface IGetCoverageParams {
  coverage_id: string
  params?: any
}

interface IPostCoverageParams {
  body: any
}

const useCoveragesResources = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  const get_coverage_action = async ({ coverage_id, params = {} }: IGetCoverageParams) => {
    try {
      return await get_module_entity_action_middleware(
        OMNIX_MODULE.OLM,
        `routes/coverages/${coverage_id}`,
        params,
        token,
        newCancelToken(),
      )
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const post_list_coverage_action = async ({ body }: IPostCoverageParams) => {
    try {
      return await post_module_entity_action_middleware(
        OMNIX_MODULE.OLM,
        `routes/coverages/all`,
        body,
        token,
        newCancelToken(),
      )
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const put_upsert_coverage_action = async ({ body }: IPostCoverageParams) => {
    try {
      return await put_module_entity_action_middleware(OMNIX_MODULE.OLM, `routes/coverages`, body, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const delete_coverage_action = async ({ body }: IPostCoverageParams) => {
    try {
      return await delete_module_entity_action_middleware(OMNIX_MODULE.OLM, `routes/coverages`, body, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  return {
    get_coverage_action,
    post_list_coverage_action,
    put_upsert_coverage_action,
    delete_coverage_action,
    loading_app,
    set_loading_app,
  }
}

export default useCoveragesResources
